import _ from 'lodash';

import publicRoutes from './publicRoutes';
import studentRoutes from './studentRoutes';
import teacherRoutes from './teacherRoutes';
import adminRoutes from './adminRoutes';

const phuongnamRoutes = _.concat(
  // ames247Routes,
  //   olympicRoutes,
  teacherRoutes,
  studentRoutes,
  publicRoutes,
  adminRoutes,
  //   onlinePracticeRoutes,
);
export default phuongnamRoutes;
